import UiTypography from '@devdept/samolet-ui/lib/components/Typography';
import { LinkProps } from 'antd/lib/typography/Link';
import styled, { css } from 'styled-components';
import { colors } from 'constants/colors';

const Typography = styled(UiTypography)``;

interface ILink extends LinkProps {
  $dashed?: boolean;
}

export const Link = styled(Typography.Link)`
  ${({ $dashed }: ILink) =>
    $dashed &&
    css`
      white-space: nowrap;
      border-bottom: 1px dashed ${colors.blue6};
    `}

  ${({ ellipsis }: ILink) =>
    ellipsis &&
    css`
      display: block !important;
    `}
`;

export const TypographyTitle = Typography.Title;
export const TypographyText = Typography.Text;
export const TypographyParagraph = styled(Typography.Paragraph)`
  margin-bottom: 0 !important;
`;
